export const AjaxRetailers = {

    selectors: {
        moreBtn: '#dynamicRetailer',
        container: '#ulSorList',
        spinner: '#ajax-spinner'
    },

    init: function() {
        $(AjaxRetailers.selectors.moreBtn).on('click', function() {
            AjaxRetailers.loadRetailers($(this).data('nextUri'));
        });
    },

    loadRetailers: function(nextUri) {
        $.ajax({
            url: nextUri,
            method: 'get',
            dataType: 'json',
            beforeSend: function() {
                $(AjaxRetailers.selectors.spinner).show();
                $(AjaxRetailers.selectors.moreBtn).attr('disabled', true);
            }
        }).done(function(data) {
            var $container = $(AjaxRetailers.selectors.container),
                $moreBtn = $(AjaxRetailers.selectors.moreBtn);
            $container.append(data['html']).find('.mix').css({
                'opacity': 1,
                'display': 'inline-block'
            });
            $container.css("height", "auto");

            if (data['nextUri']) {
                $moreBtn.data('nextUri', data['nextUri']);
                $moreBtn.show();
            } else {
                $moreBtn.hide();
            }

            $moreBtn.attr('disabled', false);
            $(AjaxRetailers.selectors.spinner).hide();
        });
    }
};
